import { createSlice } from '@reduxjs/toolkit';
import { updateLocalStorageToken, logOut } from "../../../../../../containers/resources/utils";
import axios from 'axios';

export const cancelBooking = createSlice({
  name: 'cancelBooking',
  initialState: {
    message: '',
    procesing: false,
    error: "",
  },
  reducers: {
    initialStateCancelBooking(state, action) {
      return {
        message: '',
        procesing: false,
        error: "",
      }
    },
    requesProcesing(state, action) {
      return {
        message: '',
        procesing: true,
        error: "",
      }
    },
    canceledBookingSuccess(state, action) {
      return {
        message: action.payload,
        procesing: false,
        error: "",
      }
    },
    canceledBookingError(state, action) {
      return {
        message: '',
        procesing: false,
        error: action.payload,
      }
    },
  }
})

export const canceledBooking = (booking_id, data) => dispatch => {
  dispatch(requesProcesing());
  axios.put(`/booking/${booking_id}/canceled`, data)
    .then(json => {
      if (json.data.code === 200) {
        dispatch(canceledBookingSuccess(json.data.data));
      } else if (json.data.code === 202) {
        updateLocalStorageToken(json.data.token);
        dispatch(canceledBooking(booking_id, data));
      } else if (json.data.code === 498) {
        logOut();
      } else {
        dispatch(canceledBookingError(json.data.data));
      }
    })
};

export const {
  initialStateCancelBooking,
  requesProcesing,
  canceledBookingSuccess,
  canceledBookingError,
} = cancelBooking.actions;

export default cancelBooking.reducer;